import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HighlightCardBlockConfig } from '@front-platform/content-builder';
import { highlightCardBlockResolveConfig } from '@front-platform/content-builder';
import { Observable, of } from 'rxjs';
import { Component, input } from '@angular/core';

import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
export interface HighlightCardBlockRuntimeConfig {
  'display_opened_shop'?: boolean;
  'display_closed_shop'?: boolean;
  'kiosk_card_aspect_ratio'?: string;
}

export type HighlightCardBlockConfigInput = Partial<
  Omit<HighlightCardBlockConfig, keyof HighlightCardBlockRuntimeConfig> &
    HighlightCardBlockRuntimeConfig
>;
export type HighlightCardBlockResolvedConfig = Omit<
  HighlightCardBlockConfig,
  keyof HighlightCardBlockRuntimeConfig
> &
  Partial<HighlightCardBlockRuntimeConfig>;
export interface HighlightCardBlockContract extends ConfigComponentContract<
  HighlightCardBlockConfigInput,
  HighlightCardBlockResolvedConfig
> {}

@Component({
  selector: 'app-highlight-card-block',
  templateUrl: './highlight-card-block.component.html',
  standalone: false,
})
export class HighlightCardBlockComponent implements HighlightCardBlockContract {
  readonly config = input<HighlightCardBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HighlightCardBlockConfig,
    HighlightCardBlockRuntimeConfig
  >(highlightCardBlockResolveConfig, () => ({ config: this.config() }));
  get displayOpenedShop(): boolean {
    const value = this.resolvedConfig()['display_opened_shop'];
    return value === undefined ? true : (value as unknown as boolean);
  }
  get displayClosedShop(): boolean {
    const value = this.resolvedConfig()['display_closed_shop'];
    return value === undefined ? true : (value as unknown as boolean);
  }
  get linkUrl(): string {
    return this.resolvedConfig()['link_url'] as unknown as string;
  }
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get titleSize(): 'S' | 'M' | 'L' {
    return this.resolvedConfig()['title_size'] as unknown as 'S' | 'M' | 'L';
  }
  get description(): string {
    return this.resolvedConfig()['description'] as unknown as string;
  }
  get descriptionSize(): 'S' | 'M' | 'L' {
    return this.resolvedConfig()['description_size'] as unknown as 'S' | 'M' | 'L';
  }
  get image(): IContentBuilderFieldImage {
    return this.resolvedConfig()['image'] as unknown as IContentBuilderFieldImage;
  }
  get textColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor;
  }
  get backgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor;
  }
  get displayCtaIcon(): boolean {
    return this.resolvedConfig()['display_cta_icon'] as unknown as boolean;
  }
  get kioskCardAspectRatio(): string {
    return (this.resolvedConfig()['kiosk_card_aspect_ratio'] as unknown as string) || '16/9';
  }

  componentFactoryIsBlockVisible$(): Observable<boolean> {
    return of(this.displayOpenedShop);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HighlightCardBlockComponent, { 'keyAliases': {} });
